export const QuaterOfChargeData = [
  { value: 'Quý I', label: 'Quý  I' },
  { value: 'Quý II', label: 'Quý  II' },
  { value: 'Quý III', label: 'Quý  III' },
  { value: 'Quý IV', label: 'Quý  IV' }
];

export const SubjectOfChargeData = [
  { value: 'Cố định', label: 'Cố định' },
  { value: 'Biến đổi', label: 'Biến đổi' }
];

export const WastewaterContentData = ['COD', 'TSS', 'Hg', 'Pb', 'As', 'Cd'];

export const FrequencyOfMonitoringData = [
  { value: '3 tháng', label: '3 tháng' },
  { value: '6 tháng', label: '6 tháng' },
  { value: '1 năm', label: '1 năm' }
];

export const getDataForCustomSelect = value => {
  if (!value) return null;
  return { value, label: value };
};

export const TypeMonitoringStationData = [
  { value: 'NuocThai', label: 'Quan trắc nước thải tự động, liên tục' },
  { value: 'NuocMat', label: 'Quan trắc nước mặt tự động, liên tục' },
  { value: 'NuocNgam', label: 'Quan trắc nước dưới đất tự động, liên tục' },
  { value: 'KhiThai', label: 'Quan trắc khí thải tự động, liên tục' }
];

export const AuthorityBVMTData = [
  { value: 'Cấp Tỉnh', label: 'Cấp Tỉnh' },
  { value: 'Cấp Huyện', label: 'Cấp Huyện' }
];

export const PaymentStatusData = [
  { value: 'Đã nộp', label: 'Đã nộp' },
  { value: 'Chưa nộp', label: 'Chưa nộp' }
];

export const SecurityLevelData = [{ value: 'Bạn đọc', label: 'Bạn đọc' }];

export const VungCapNuocData = [
  {
    name: 'Sông Thị Tính',
    children: [
      {
        name: 'Sông Thị Tính'
      },
      {
        name: 'Hệ thống Suối Thơ Dương, văn Tám - Suối Bát'
      },
      {
        name: 'Hệ thống suối Cầu Trắc - Suối Cốm'
      },
      {
        name: 'Hệ thống Suối Ông Chài, Bà Tứ - Hố Đỏ'
      },
      {
        name: 'Hệ thống Suối Lồ Ồ, Cái Liêu Ống Thành – Căm Xe'
      },
      {
        name: 'Rạch Thằng Nô'
      },
      {
        name: 'Suối Hồ Muồng'
      },
      {
        name: 'Hệ thống Suối Nhà Mát – Cầu Trật'
      },
      {
        name: 'Hệ thống suối Bến Ván, Đòn Gánh, Đồng Sổ - Bà Lăng, Chà Vi'
      },
      {
        name: 'Hệ thống Suối Ông Tề, Bông trang - Bến Tượng'
      },
      {
        name: 'Hệ thống Suối Tre - Rạch Chồm Chổm'
      },
      {
        name: 'Hệ thống Suối Bà Cẩn, Suối Cầu Đôn, Suối Nhánh - Rạch Bến Trắc'
      },
      {
        name: 'Rạch Bà Phó'
      },
      {
        name: 'Hệ thống rạch Cây Bàng, Tân Định - Suối Cầu Định'
      }
    ]
  },
  {
    name: 'Sông Sài Gòn',
    children: [
      {
        name: 'Sông Sài Gòn'
      },
      {
        name: 'Suối Cát (Dầu Tiếng)'
      },
      {
        name: 'Suối Dứa'
      },
      {
        name: 'Rạch Cần Nôm'
      },
      {
        name: 'Rạch Xuy Nô'
      },
      {
        name: 'Rạch Sơn'
      },
      {
        name: 'Rạch Gò Cát'
      },
      {
        name: 'Hệ thống Rạch Mương Dâu'
      },
      {
        name: 'Rạch Cầu Điền'
      },
      {
        name: 'Rạch Miến'
      },
      {
        name:
          'Hệ thống suối Giữa - Bưng Cầu - rạch Bà Cô, rạch Trầu (Hồ Ông Thiềng)'
      },
      {
        name: 'Rạch Ông Đành'
      },
      {
        name: 'Rạch Thầy Năng'
      },
      {
        name: 'Rạch Thổ Ngữ'
      },
      {
        name: 'Rạch Bàu Bàng (Rạch Chủ Hiếu)'
      },
      {
        name: 'Hệ thống Suối Cát, Bưng Biệc - rạch Bà Lụa'
      },
      {
        name: 'Hệ thống Chòm Sao, Rạch Cây Trâm - rạch Vàm Búng'
      },
      {
        name: 'Hệ thống Suối Đờn - rạch Cầu Đò - rạch Bình Nhâm (rạch Cầu Mới)'
      },
      {
        name: 'Hệ thống kênh Visip - Bình Hòa - Ông Bố - Vĩnh Bình'
      },
      {
        name: 'Rạch Lái Thiêu'
      },
      {
        name: 'Kênh Ba Bò – rạch Vĩnh Bình'
      }
    ]
  },
  {
    name: 'Sông Bé',
    children: [
      {
        name: 'Sông Bé'
      },
      {
        name: 'Suối Nước Trong'
      },
      {
        name: 'Hệ thống Suối Nước Vàng - Suối Giai'
      },
      {
        name: 'Hệ thống Suối Đồng Sen, Rạch Bé, Suối Đá, suối Gia Hú – Suối Rạc'
      },
      {
        name: 'Hệ thống Suối Bàu Long, Suối Đồn – Suối Thôn'
      },
      {
        name: 'Hệ thống Suối Ông Bằng – Suối Chéo'
      },
      {
        name: 'Hệ thống Suối Bà Tảo, Suối Dâu  – Suối Bẩy Giới'
      },
      {
        name: 'Hệ thống Suối Bàu Cỏ - Rạch Ngang'
      },
      {
        name: 'Hệ thống Suối Xè'
      },
      {
        name: 'Hệ thống Suối Cảnh Chinh, suối Sen, Bàu Gốc'
      },
      {
        name: 'Hệ thống Suối Ngan, Suối Oi – Suối Dầm Tư'
      },
      {
        name: 'Hệ thống Suối Đỉa'
      },
      {
        name: 'Hệ thống Suối Đá Bàn'
      }
    ]
  },
  {
    name: 'Sông Đồng Nai',
    children: [
      {
        name: 'Sông Đồng Nai'
      },
      {
        name: 'Hệ thống suối Đá Bìa - Suối Cầu'
      },
      {
        name: 'Hệ thống Suối Tân Lợi, Hồ Đá Bàn - Đá Bàn - Suối Sâu - Vũng Gấm'
      },
      {
        name: 'Hệ thống Suối Rạch Xếp'
      },
      {
        name: 'Hệ thống Suối Cầu Gồ'
      },
      {
        name: 'Hệ thống Suối Tre'
      },
      {
        name:
          'Hệ thống Suối Cái – Rạch Cái, Rạch Ông Tổng Bảng (Suối Trại Cưa, Suối Tre, Suối Bến Xoài, Suối Đôi, suối Vĩnh lai, suối Chợ, Suối Ông Đông, Rạch Bà Phó, Suối Con, suối Cái, Suối Miếu Bà Tô …)'
      },
      {
        name: 'Hệ thống Suối Bưng Cầu - rạch Giữa - Rạch Cái'
      },
      {
        name:
          'Hệ thống kênh T5A - Suối Siệp, rạch Lồ Ồ, rạch Bình Thắng, rạch Bà Khâm – Rạch Tân Vạn'
      },
      {
        name: 'Suối Nhum'
      }
    ]
  },
  {
    name: 'Tự thấm',
  }
];

export const ThongBaoLanData = [
  { value: 'Lần 1', label: 'Lần 1' },
  { value: 'Lần 2', label: 'Lần 2' },
  { value: 'Lần 3', label: 'Lần 3' },
  { value: 'Lần 4', label: 'Lần 4' },
  { value: 'Lần 5', label: 'Lần 5' },
  { value: 'Lần 6', label: 'Lần 6' },
  { value: 'Lần 7', label: 'Lần 7' },
  { value: 'Lần 8', label: 'Lần 8' },
  { value: 'Lần 9', label: 'Lần 9' },
  { value: 'Lần 10', label: 'Lần 10' }
];

export const LoaiThongBaoData = [
  { value: 'Nộp phí', label: 'Nộp phí' },
  { value: 'Kê khai lại', label: 'Kê khai lại' }
];

export const DOI_TUONG = {
  DANH_GIA_TAC_DONG_MOI_TRUONG: 'Hồ sơ môi trường',
  KE_HOACH_BAO_VE_MOI_TRUONG: 'Kế hoạch bảo vệ môi trường'
};
export const DoiTuongData = [
  {
    value: DOI_TUONG.DANH_GIA_TAC_DONG_MOI_TRUONG,
    label: DOI_TUONG.DANH_GIA_TAC_DONG_MOI_TRUONG
  },
  {
    value: DOI_TUONG.KE_HOACH_BAO_VE_MOI_TRUONG,
    label: DOI_TUONG.KE_HOACH_BAO_VE_MOI_TRUONG
  }
];

export const BunThaiData = [
  { value: '1 sao', label: '1 sao' },
  { value: '2 sao', label: '2 sao' }
];

export const KetQuaQuanTracData = [
  { value: 'Đạt', label: 'Đạt' },
  { value: 'Vuợt', label: 'Vuợt' }
];

export const HinhThucNopData = [
  { value: 'Nộp hàng năm', label: 'Nộp hàng năm' },
  { value: 'Nộp báo cáo lần đầu', label: 'Nộp báo cáo lần đầu' }
];



// WEBPACK FOOTER //
// ./src/constants/custom-data.js